var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1644572749796,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2998,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M581.046 743.398H442.954c-86.134 0-156.206-70.062-156.206-156.196v-355.55c0-86.134 70.072-156.196 156.206-156.196h138.091c86.124 0 156.196 70.062 156.196 156.196v355.551c0.001 86.134-70.071 156.195-156.195 156.195zM442.954 117.07c-63.183 0-114.592 51.408-114.592 114.582v355.551c0 63.173 51.408 114.582 114.592 114.582h138.091c63.183 0 114.582-51.408 114.582-114.582V231.652c0-63.173-51.398-114.582-114.582-114.582H442.954z",
    fill: "",
    "p-id": 2999
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.345 290.375H311.071c-11.491 0-20.807-9.306-20.807-20.807s9.316-20.807 20.807-20.807h103.274c11.491 0 20.807 9.306 20.807 20.807s-9.317 20.807-20.807 20.807zM418.144 423.326H314.87c-11.491 0-20.807-9.306-20.807-20.807s9.316-20.807 20.807-20.807h103.274c11.491 0 20.807 9.306 20.807 20.807s-9.316 20.807-20.807 20.807zM418.144 570.093H314.87c-11.491 0-20.807-9.306-20.807-20.807s9.316-20.807 20.807-20.807h103.274c11.491 0 20.807 9.306 20.807 20.807s-9.316 20.807-20.807 20.807zM698.716 290.375H595.442c-11.491 0-20.807-9.306-20.807-20.807s9.317-20.807 20.807-20.807h103.274c11.491 0 20.807 9.306 20.807 20.807s-9.316 20.807-20.807 20.807zM702.526 423.326H599.242c-11.491 0-20.807-9.306-20.807-20.807s9.317-20.807 20.807-20.807h103.284c11.491 0 20.807 9.306 20.807 20.807s-9.317 20.807-20.807 20.807zM702.526 570.093H599.242c-11.491 0-20.807-9.306-20.807-20.807s9.317-20.807 20.807-20.807h103.284c11.491 0 20.807 9.306 20.807 20.807s-9.317 20.807-20.807 20.807z",
    fill: "",
    "p-id": 3000
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M550.688 859.443h-77.377c-150.202 0-272.393-94.831-272.393-211.404V437.61c0-11.501 9.316-20.807 20.807-20.807 11.491 0 20.807 9.306 20.807 20.807v210.429c0 93.632 103.528 169.79 230.779 169.79h77.377c127.251 0 230.779-76.157 230.779-169.79V437.61c0-11.501 9.317-20.807 20.807-20.807s20.807 9.306 20.807 20.807v210.429c0 116.573-122.191 211.404-272.393 211.404z",
    fill: "",
    "p-id": 3001
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M797.702 513.422h-67.451c-11.491 0-20.807-9.306-20.807-20.807s9.317-20.807 20.807-20.807h67.451c11.491 0 20.807 9.306 20.807 20.807s-9.316 20.807-20.807 20.807z",
    fill: "",
    "p-id": 3002
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288.099 513.422h-60.715c-11.491 0-20.807-9.306-20.807-20.807s9.316-20.807 20.807-20.807h60.715c11.491 0 20.807 9.306 20.807 20.807s-9.316 20.807-20.807 20.807z",
    fill: "",
    "p-id": 3003
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M512 941.107c-11.491 0-20.807-9.306-20.807-20.807V736.205c0-11.501 9.316-20.807 20.807-20.807s20.807 9.306 20.807 20.807V920.3c0 11.501-9.316 20.807-20.807 20.807z",
    fill: "",
    "p-id": 3004
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M610.214 948.544H413.786c-11.491 0-20.807-9.306-20.807-20.807s9.316-20.807 20.807-20.807h196.429c11.491 0 20.807 9.306 20.807 20.807-0.001 11.501-9.317 20.807-20.808 20.807z",
    fill: "",
    "p-id": 3005
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.eeaf3b74.svg";
export { ForwardRef as ReactComponent };